import { createSelector } from 'reselect';
import { getReportsList } from '../../../selectors';

const getRequestId = (state, ownProps) => ownProps.requestId;
const getRequestName = (state, ownProps) => ownProps.requestName;

export const selectReportCategoryDetails = createSelector(
    [getRequestId, getReportsList],
    (id, reports) => reports.find(r => r.reportId === id) || null
);



// WEBPACK FOOTER //
// ./app/web/src/container/RequestReportPage/Form/selectors.jsx